export default {
  SET_REPOSITORIES: 'setRepositories',
  SET_SELECTED_REPOSITORY: 'setSelectedRepository',
  SET_FIELD_FILE_SERVERS: 'setFieldFileServers',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_INACTIVE_FILTER_VAL: 'setInactiveFilterVal',
}